(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[493],{

/***/ 1848:
/***/ (function(module) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),

/***/ 7740:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIteratee = __webpack_require__(7206),
    isArrayLike = __webpack_require__(8612),
    keys = __webpack_require__(3674);

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike(collection)) {
      var iteratee = baseIteratee(predicate, 3);
      collection = keys(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

module.exports = createFind;


/***/ }),

/***/ 3311:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createFind = __webpack_require__(7740),
    findIndex = __webpack_require__(998);

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find = createFind(findIndex);

module.exports = find;


/***/ }),

/***/ 998:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(1848),
    baseIteratee = __webpack_require__(7206),
    toInteger = __webpack_require__(554);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;


/***/ }),

/***/ 6319:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ formatTimeToISO; }
/* harmony export */ });
var formatTimeToISO = function formatTimeToISO(d) {
  if (!d) {
    return '';
  }

  return new Date(d).toISOString();
};

/***/ }),

/***/ 1332:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ useImageProxy; }
/* harmony export */ });
var prod = true; // const image_proxy_url = process.env.NEXT_PUBLIC_WEBAPP_IMAGE_ADDRESS
// function to stringify url image to pass in image proxy 

function useImageProxy(url, enabled) {
  if (!prod || !enabled || !url || url == 'undefined') {
    return url;
  }

  var value = "/image/".concat(url.replace('/image/', ''));
  return value;
}

/***/ }),

/***/ 8000:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.AmpStateContext = void 0;

var _interop_require_default = (__webpack_require__(2648)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(7294));

var AmpStateContext = _react["default"].createContext({});

exports.AmpStateContext = AmpStateContext;

if (false) {}

/***/ }),

/***/ 9470:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.isInAmpMode = isInAmpMode;

function isInAmpMode() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$ampFirst = _ref.ampFirst,
      ampFirst = _ref$ampFirst === void 0 ? false : _ref$ampFirst,
      _ref$hybrid = _ref.hybrid,
      hybrid = _ref$hybrid === void 0 ? false : _ref$hybrid,
      _ref$hasQuery = _ref.hasQuery,
      hasQuery = _ref$hasQuery === void 0 ? false : _ref$hasQuery;

  return ampFirst || hybrid && hasQuery;
}

/***/ }),

/***/ 2717:
/***/ (function(module, exports, __webpack_require__) {

"client";
"use strict";

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.defaultHead = defaultHead;
exports["default"] = void 0;

var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);

var _interop_require_default = (__webpack_require__(2648)/* ["default"] */ .Z);

var _interop_require_wildcard = (__webpack_require__(1598)/* ["default"] */ .Z);

var _react = _interop_require_wildcard(__webpack_require__(7294));

var _sideEffect = _interop_require_default(__webpack_require__(1585));

var _ampContext = __webpack_require__(8000);

var _headManagerContext = __webpack_require__(5850);

var _ampMode = __webpack_require__(9470);

var _utils = __webpack_require__(9475);

'client';

function defaultHead() {
  var inAmpMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var head = [/*#__PURE__*/_react["default"].createElement("meta", {
    charSet: "utf-8"
  })];

  if (!inAmpMode) {
    head.push( /*#__PURE__*/_react["default"].createElement("meta", {
      name: "viewport",
      content: "width=device-width"
    }));
  }

  return head;
}

function onlyReactElement(list, child) {
  // React children can be "string" or "number" in this case we ignore them for backwards compat
  if (typeof child === 'string' || typeof child === 'number') {
    return list;
  } // Adds support for React.Fragment


  if (child.type === _react["default"].Fragment) {
    return list.concat(_react["default"].Children.toArray(child.props.children).reduce(function (fragmentList, fragmentChild) {
      if (typeof fragmentChild === 'string' || typeof fragmentChild === 'number') {
        return fragmentList;
      }

      return fragmentList.concat(fragmentChild);
    }, []));
  }

  return list.concat(child);
}

var METATYPES = ['name', 'httpEquiv', 'charSet', 'itemProp'];
/*
 returns a function for filtering head child elements
 which shouldn't be duplicated, like <title/>
 Also adds support for deduplicated `key` properties
*/

function unique() {
  var keys = new Set();
  var tags = new Set();
  var metaTypes = new Set();
  var metaCategories = {};
  return function (h) {
    var isUnique = true;
    var hasKey = false;

    if (h.key && typeof h.key !== 'number' && h.key.indexOf('$') > 0) {
      hasKey = true;
      var key = h.key.slice(h.key.indexOf('$') + 1);

      if (keys.has(key)) {
        isUnique = false;
      } else {
        keys.add(key);
      }
    } // eslint-disable-next-line default-case


    switch (h.type) {
      case 'title':
      case 'base':
        if (tags.has(h.type)) {
          isUnique = false;
        } else {
          tags.add(h.type);
        }

        break;

      case 'meta':
        for (var i = 0, len = METATYPES.length; i < len; i++) {
          var metatype = METATYPES[i];
          if (!h.props.hasOwnProperty(metatype)) continue;

          if (metatype === 'charSet') {
            if (metaTypes.has(metatype)) {
              isUnique = false;
            } else {
              metaTypes.add(metatype);
            }
          } else {
            var category = h.props[metatype];
            var categories = metaCategories[metatype] || new Set();

            if ((metatype !== 'name' || !hasKey) && categories.has(category)) {
              isUnique = false;
            } else {
              categories.add(category);
              metaCategories[metatype] = categories;
            }
          }
        }

        break;
    }

    return isUnique;
  };
}
/**
 *
 * @param headChildrenElements List of children of <Head>
 */


function reduceComponents(headChildrenElements, props) {
  var inAmpMode = props.inAmpMode;
  return headChildrenElements.reduce(onlyReactElement, []).reverse().concat(defaultHead(inAmpMode).reverse()).filter(unique()).reverse().map(function (c, i) {
    var key = c.key || i;

    if ( true && !inAmpMode) {
      if (c.type === 'link' && c.props['href'] && // TODO(prateekbh@): Replace this with const from `constants` when the tree shaking works.
      ['https://fonts.googleapis.com/css', 'https://use.typekit.net/'].some(function (url) {
        return c.props['href'].startsWith(url);
      })) {
        var newProps = _extends({}, c.props || {});

        newProps['data-href'] = newProps['href'];
        newProps['href'] = undefined; // Add this attribute to make it easy to identify optimized tags

        newProps['data-optimized-fonts'] = true;
        return /*#__PURE__*/_react["default"].cloneElement(c, newProps);
      }
    }

    if (false) { var srcMessage; }

    return /*#__PURE__*/_react["default"].cloneElement(c, {
      key: key
    });
  });
}
/**
 * This component injects elements to `<head>` of your page.
 * To avoid duplicated `tags` in `<head>` you can use the `key` property, which will make sure every tag is only rendered once.
 */


function Head(_ref) {
  var children = _ref.children;
  var ampState = (0, _react).useContext(_ampContext.AmpStateContext);
  var headManager = (0, _react).useContext(_headManagerContext.HeadManagerContext);
  return /*#__PURE__*/_react["default"].createElement(_sideEffect["default"], {
    reduceComponentsToState: reduceComponents,
    headManager: headManager,
    inAmpMode: (0, _ampMode).isInAmpMode(ampState)
  }, children);
}

var _default = Head;
exports["default"] = _default;

if ((typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) && typeof exports["default"].__esModule === 'undefined') {
  Object.defineProperty(exports["default"], '__esModule', {
    value: true
  });
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 1585:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = SideEffect;

var _interop_require_wildcard = (__webpack_require__(1598)/* ["default"] */ .Z);

var _react = _interop_require_wildcard(__webpack_require__(7294));

function SideEffect(props) {
  var headManager = props.headManager,
      reduceComponentsToState = props.reduceComponentsToState;

  function emitChange() {
    if (headManager && headManager.mountedInstances) {
      var headElements = _react.Children.toArray(Array.from(headManager.mountedInstances).filter(Boolean));

      headManager.updateHead(reduceComponentsToState(headElements, props));
    }
  }

  if (isServer) {
    var ref;
    headManager == null ? void 0 : (ref = headManager.mountedInstances) == null ? void 0 : ref.add(props.children);
    emitChange();
  }

  useClientOnlyLayoutEffect(function () {
    var ref1;
    headManager == null ? void 0 : (ref1 = headManager.mountedInstances) == null ? void 0 : ref1.add(props.children);
    return function () {
      var ref;
      headManager == null ? void 0 : (ref = headManager.mountedInstances) == null ? void 0 : ref["delete"](props.children);
    };
  }); // We need to call `updateHead` method whenever the `SideEffect` is trigger in all
  // life-cycles: mount, update, unmount. However, if there are multiple `SideEffect`s
  // being rendered, we only trigger the method from the last one.
  // This is ensured by keeping the last unflushed `updateHead` in the `_pendingUpdate`
  // singleton in the layout effect pass, and actually trigger it in the effect pass.

  useClientOnlyLayoutEffect(function () {
    if (headManager) {
      headManager._pendingUpdate = emitChange;
    }

    return function () {
      if (headManager) {
        headManager._pendingUpdate = emitChange;
      }
    };
  });
  useClientOnlyEffect(function () {
    if (headManager && headManager._pendingUpdate) {
      headManager._pendingUpdate();

      headManager._pendingUpdate = null;
    }

    return function () {
      if (headManager && headManager._pendingUpdate) {
        headManager._pendingUpdate();

        headManager._pendingUpdate = null;
      }
    };
  });
  return null;
}

var isServer = false;
var useClientOnlyLayoutEffect = isServer ? function () {} : _react.useLayoutEffect;
var useClientOnlyEffect = isServer ? function () {} : _react.useEffect;

/***/ }),

/***/ 9854:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Seo; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(9499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./providers/ServerSideProps/index.tsx + 539 modules
var ServerSideProps = __webpack_require__(7083);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./providers/Seo/author/index.tsx


function useAuthor(_ref) {
  var enabled = _ref.enabled,
      author = _ref.author;

  if (!enabled) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: author && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "author",
      content: author
    }, 'author')
  });
}
;// CONCATENATED MODULE: ./providers/Seo/canonical/index.tsx



function useCanonical(_ref) {
  var enabled = _ref.enabled,
      url = _ref.url;

  if (!enabled) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "canonical",
      href: url
    })
  });
}
;// CONCATENATED MODULE: ./providers/Seo/description/index.tsx


function useDescription(_ref) {
  var enabled = _ref.enabled,
      description = _ref.description;

  if (!enabled) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: description && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "description",
      content: description
    }, 'description')
  });
}
;// CONCATENATED MODULE: ./providers/Seo/facebook/index.tsx



function useFacebookSEO(_ref) {
  var enabled = _ref.enabled,
      appId = _ref.appId,
      pageId = _ref.pageId;

  if (!enabled) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [appId && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      property: "fb:app_id",
      content: appId
    }, 'fbappid'), pageId && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      property: "fb:pages",
      content: pageId
    }, 'fbpageid')]
  });
}
;// CONCATENATED MODULE: ./providers/Seo/keywords/index.tsx


function useKeywords(_ref) {
  var enabled = _ref.enabled,
      keywords = _ref.keywords;

  if (!enabled) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: keywords && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "keywords",
      property: "keywords",
      content: keywords
    }, 'keywords')
  });
}
;// CONCATENATED MODULE: ./providers/Seo/ogp/index.tsx



function useOpenGraphProtocol(_ref) {
  var enabled = _ref.enabled,
      pageDescription = _ref.pageDescription,
      pageLocale = _ref.pageLocale,
      pageTitle = _ref.pageTitle,
      pageType = _ref.pageType,
      pageUrl = _ref.pageUrl,
      siteName = _ref.siteName;

  if (!enabled) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [pageDescription && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      property: "og:description",
      content: pageDescription
    }, 'og_description'), pageLocale && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      property: "og:locale",
      content: pageLocale
    }, 'og_locale'), siteName && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      property: "og:site_name",
      content: siteName
    }, 'og_site_name'), pageTitle && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      property: "og:title",
      content: pageTitle
    }, 'og_title'), pageType && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      property: "og:type",
      content: pageType
    }, 'og_type'), pageUrl && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      property: "og:url",
      content: pageUrl
    }, 'og_url')]
  });
}
;// CONCATENATED MODULE: ./providers/Seo/ogp/article.tsx




/**
 * Open Graph Article hook
 * https://ogp.me/#type_article÷
 * @param param0 
 * @returns 
 */
function useOpenGraphArticle(_ref) {
  var enabled = _ref.enabled,
      pageAuthor = _ref.pageAuthor,
      pageKeywords = _ref.pageKeywords,
      pageModifiedDate = _ref.pageModifiedDate,
      pagePublishedDate = _ref.pagePublishedDate,
      section = _ref.section;

  if (!enabled) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
  }

  var parseKeywords = function parseKeywords() {
    if (typeof pageKeywords === 'string') {
      return pageKeywords.split(', ').map(function (i, k) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
          property: "article:tag",
          content: i
        }, "og_article_keywords_".concat(i).concat(k));
      });
    }

    if (Array.isArray(pageKeywords)) {
      return pageKeywords.map(function (i, k) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
          property: "article:tag",
          content: i
        }, "og_article_keywords_".concat(i).concat(k));
      });
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [pageModifiedDate && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      property: "article:modified_time",
      content: pageModifiedDate
    }, 'og_article_modified_time'), pagePublishedDate && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      property: "article:published_time",
      content: pagePublishedDate
    }, 'og_article_published_time'), pageAuthor && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      property: "article:author",
      content: pageAuthor
    }, 'og_article_author'), pageKeywords && parseKeywords(), section && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      property: "article:section",
      name: "article:section",
      content: section
    }, 'og_article_section')]
  });
}
;// CONCATENATED MODULE: ./providers/Seo/ogp/image.tsx





/**
 * Open Graph image hook
 * https://ogp.me/#structured
 * @param param0 
 * @returns 
 */
function useOpenGraphImages(_ref) {
  var enabled = _ref.enabled,
      pageImages = _ref.pageImages;

  if (!enabled) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
  }

  return pageImages && pageImages.map(function (i, k) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
      children: [i.url && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image",
        content: i.url
      }, 'og_image'), i.secureUrl && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image:secure_url",
        content: i.secureUrl
      }, 'og_image_secure'), i.type && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image:type",
        content: i.type
      }, 'og_image_type'), i.width && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image:width",
        content: i.width
      }, 'og_image_width'), i.height && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image:height",
        content: i.height
      }, 'og_image_height'), i.alt && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image:alt",
        content: i.alt
      }, 'og_image_alt')]
    }, k);
  });
}
;// CONCATENATED MODULE: ./providers/Seo/robots/index.tsx


function useRobots(_ref) {
  var enabled = _ref.enabled,
      robotsOptions = _ref.robotsOptions;

  if (!enabled) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
  }

  var opts = [];

  if (robotsOptions !== null && robotsOptions !== void 0 && robotsOptions.noarchive) {
    opts.push('noarchive');
  }

  if (robotsOptions !== null && robotsOptions !== void 0 && robotsOptions.nofollow) {
    opts.push('nofollow');
  }

  if (robotsOptions !== null && robotsOptions !== void 0 && robotsOptions.noimageindex) {
    opts.push('noimageindex');
  }

  if (robotsOptions !== null && robotsOptions !== void 0 && robotsOptions.noindex) {
    opts.push('noindex');
  }

  if (robotsOptions !== null && robotsOptions !== void 0 && robotsOptions.nositelinkssearchbox) {
    opts.push('nositelinkssearchbox');
  }

  if (robotsOptions !== null && robotsOptions !== void 0 && robotsOptions.nosnippet) {
    opts.push('nosnippet');
  }

  if (robotsOptions !== null && robotsOptions !== void 0 && robotsOptions.notranslate) {
    opts.push('notranslate');
  }

  if (robotsOptions !== null && robotsOptions !== void 0 && robotsOptions.unavailable_after) {
    var _robotsOptions$unavai;

    opts.push("unavailable_after: ".concat(robotsOptions === null || robotsOptions === void 0 ? void 0 : (_robotsOptions$unavai = robotsOptions.unavailable_after) === null || _robotsOptions$unavai === void 0 ? void 0 : _robotsOptions$unavai.date));
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: opts.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "robots",
      content: opts.join(', ')
    }, 'robots')
  });
}
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(7812);
// EXTERNAL MODULE: ./formatters/parseTime.ts
var parseTime = __webpack_require__(6319);
// EXTERNAL MODULE: ./hooks/useImageProxy.tsx
var useImageProxy = __webpack_require__(1332);
// EXTERNAL MODULE: ./utils/getDepFromNav.js
var getDepFromNav = __webpack_require__(586);
;// CONCATENATED MODULE: ./utils/site.js
var site = {
  OPOPULAR: {
    name: 'opopular.d',
    slug: 'opopular'
  },
  DAQUI: {
    name: 'daqui.d',
    slug: 'daqui'
  },
  CBNGO: {
    name: 'cbngo.d',
    slug: 'cbngo'
  },
  CBNTO: {
    name: 'cbnto.d',
    slug: 'cbnto'
  },
  TOCANTINS: {
    name: 'tocantins.d',
    slug: 'tocantins'
  }
};

function getSiteData(siteSlug) {
  switch (siteSlug) {
    case 'opopular':
      return site.OPOPULAR;

    case 'daqui':
      return site.DAQUI;

    case 'cbngo':
      return site.CBNGO;

    case 'cbnto':
      return site.CBNTO;

    case 'tocantins':
      return site.TOCANTINS;

    default:
      return {
        name: ""
      };
  }
}


;// CONCATENATED MODULE: ./utils/getThumbUrl.js

function getThumbUrl(siteSlug) {
  switch (siteSlug) {
    case site.TOCANTINS.slug:
      return {
        url: '/assets/tocantins/banners/BannerSocialShare.png',
        type: 'jpeg',
        height: '500',
        width: '1000'
      };

    case site.DAQUI.slug:
      return {
        url: '/assets/daqui/banners/BannerSocialShare.png',
        type: 'jpeg',
        height: '500',
        width: '1000'
      };

    case site.CBNGO.slug:
      return {
        url: '/assets/cbngo/banners/BannerSocialShare.png',
        type: 'jpeg',
        height: '500',
        width: '1000'
      };

    case site.CBNTO.slug:
      return {
        url: '/assets/cbnto/banners/BannerSocialShare.png',
        type: 'jpeg',
        height: '500',
        width: '1000'
      };

    default:
      return {
        url: '/assets/opopular/banners/BannerSocialShare.png',
        type: 'jpeg',
        height: '500',
        width: '1000'
      };
  }
}
;// CONCATENATED MODULE: ./providers/Seo/strategy.tsx


/* eslint-disable react-hooks/rules-of-hooks */






var useSeoStrategy = function useSeoStrategy() {
  var _serverSideContext$pa, _serverSideContext$ar;

  var serverSideContext = (0,react.useContext)(ServerSideProps.ServerSidePropsContext);
  var strategy_type = (serverSideContext === null || serverSideContext === void 0 ? void 0 : (_serverSideContext$pa = serverSideContext.pageType) === null || _serverSideContext$pa === void 0 ? void 0 : _serverSideContext$pa.type) || 'home';
  var domain = serverSideContext.domain;
  var site = serverSideContext.site;
  var page = serverSideContext.page;
  var article = (serverSideContext === null || serverSideContext === void 0 ? void 0 : (_serverSideContext$ar = serverSideContext.article) === null || _serverSideContext$ar === void 0 ? void 0 : _serverSideContext$ar[0]) || {};
  var thumbData = getThumbUrl(site === null || site === void 0 ? void 0 : site.pathSegment);
  var nav = serverSideContext.navigation || {};
  var fullNav = [];
  var menuActions = (nav === null || nav === void 0 ? void 0 : nav.menuActions) || [];
  var menuSide = (nav === null || nav === void 0 ? void 0 : nav.menuSide) || [];
  var menuTop = (nav === null || nav === void 0 ? void 0 : nav.menuTop) || [];
  var prevNav = [].concat((0,toConsumableArray/* default */.Z)(menuActions), (0,toConsumableArray/* default */.Z)(menuSide), (0,toConsumableArray/* default */.Z)(menuTop));

  for (var i = 0; i < prevNav.length; i++) {
    var it = prevNav[i];
    fullNav.push({
      name: it === null || it === void 0 ? void 0 : it.name,
      path: it === null || it === void 0 ? void 0 : it.path
    });
    var subItems = (it === null || it === void 0 ? void 0 : it.subItems) || [];

    for (var j = 0; j < subItems.length; j++) {
      var sit = subItems[j];
      fullNav.push({
        name: sit === null || sit === void 0 ? void 0 : sit.name,
        path: sit === null || sit === void 0 ? void 0 : sit.path
      });
    }
  }

  function parseMainSection(path) {
    var navItems = path ? (0,getDepFromNav/* getPageTitleFromPath */.$)(fullNav, path) : [];
    return navItems[0] ? navItems[0] : '';
  }

  function parseArticleKeywords(tags) {
    if (!tags) {
      return '';
    }

    return tags.join(', ');
  }

  function parseComposedTitle(title, path, siteName) {
    var navItems = path ? (0,getDepFromNav/* getPageTitleFromPath */.$)(fullNav, path) : [];
    var parsed = navItems.reverse();
    var composedTitle = parsed.join(' | ');
    return "".concat(title ? title : composedTitle, " | ").concat(siteName);
  }

  function checkMediaVideoType(data) {
    var _video$slotTemplateCo;

    var regexToMatch = new RegExp('class="youtube-video"');
    var regexToMatchUrl = new RegExp(/src="([^"]*)"/);
    var embeds = data === null || data === void 0 ? void 0 : data.filter(function (i) {
      return (i === null || i === void 0 ? void 0 : i.inputTemplate) === 'br.com.atex.templates.articleEmbed.it';
    });
    var videoComponents = data === null || data === void 0 ? void 0 : data.filter(function (i) {
      return (i === null || i === void 0 ? void 0 : i.inputTemplate) === 'br.com.atex.templates.articleVideo.it';
    });
    var video = embeds === null || embeds === void 0 ? void 0 : embeds.find(function (i) {
      return i === null || i === void 0 ? void 0 : i.slotTemplateCode.match(regexToMatch);
    });
    var videoComponent = videoComponents && videoComponents[0] || null;
    var url = (video === null || video === void 0 ? void 0 : (_video$slotTemplateCo = video.slotTemplateCode) === null || _video$slotTemplateCo === void 0 ? void 0 : _video$slotTemplateCo.match(regexToMatchUrl)) || [];

    if (!(video !== null && video !== void 0 && video.inputTemplate) && !(videoComponent !== null && videoComponent !== void 0 && videoComponent.inputTemplate)) {
      return {
        enabled: false,
        name: '',
        publishedDate: null,
        url: ''
      };
    } else {
      if (video !== null && video !== void 0 && video.inputTemplate) {
        return {
          enabled: true,
          name: video.name,
          publishedDate: new Date(video === null || video === void 0 ? void 0 : video.publishingTime).toISOString(),
          url: url.length > 1 ? url[1] : ''
        };
      }

      if (videoComponent !== null && videoComponent !== void 0 && videoComponent.inputTemplate) {
        return {
          enabled: true,
          name: (videoComponent === null || videoComponent === void 0 ? void 0 : videoComponent.name) || '',
          publishedDate: new Date(videoComponent === null || videoComponent === void 0 ? void 0 : videoComponent.publishingTime).toISOString(),
          url: "https://cdn.ojc.com.br/videos/mp4/".concat(videoComponent === null || videoComponent === void 0 ? void 0 : videoComponent.link) || 0
        };
      }

      return {
        enabled: false,
        name: '',
        publishedDate: null,
        url: ''
      };
    }
  }

  if (strategy_type === 'article') {
    var _article$images, _article$tags, _site$pageSocialData, _site$pageSocialData2, _site$pageSocialData3, _site$pageSocialData4, _article$author, _article$author2, _article$author3;

    var hasMediaVideoType = checkMediaVideoType(article.bodyItems);
    var images = [];
    var sImages = [];

    if (article !== null && article !== void 0 && article.images && (article === null || article === void 0 ? void 0 : (_article$images = article.images) === null || _article$images === void 0 ? void 0 : _article$images.length) > 0) {
      article.images.forEach(function (i) {
        var baseUrl = "".concat(domain).concat((0,useImageProxy/* useImageProxy */.n)("".concat(i.url, "f=3x2"), true));
        images.push({
          url: baseUrl,
          secureUrl: baseUrl,
          type: 'image/jpg',
          alt: i.title
        });
        sImages.push(baseUrl);
      });
    }

    return {
      viewport: {
        enabled: true,
        initialScale: '1',
        minimumScale: '1',
        shrinkToFit: true,
        viewportFit: 'cover',
        width: 'device-width'
      },
      title: {
        enabled: true,
        title: (article === null || article === void 0 ? void 0 : article.metadataTitle) !== '' ? article.metadataTitle : "".concat(article.name, " | ").concat(site.name)
      },
      description: {
        enabled: true,
        description: (article === null || article === void 0 ? void 0 : article.metadataDescription) !== '' ? article.metadataDescription : article !== null && article !== void 0 && article.lead ? article.lead : ''
      },
      canonical: {
        enabled: true,
        url: "".concat(domain).concat(article === null || article === void 0 ? void 0 : article.path)
      },
      keywords: {
        enabled: true,
        keywords: parseArticleKeywords((article === null || article === void 0 ? void 0 : (_article$tags = article.tags) === null || _article$tags === void 0 ? void 0 : _article$tags.tags) || null)
      },
      openGraphArticle: {
        enabled: true,
        pageModifiedDate: (0,parseTime/* formatTimeToISO */.N)(article === null || article === void 0 ? void 0 : article.modificationTime),
        pagePublishedDate: (0,parseTime/* formatTimeToISO */.N)(article === null || article === void 0 ? void 0 : article.publishingTime),
        pageKeywords: (article === null || article === void 0 ? void 0 : article.metadataKeywords) || (article === null || article === void 0 ? void 0 : article.tags) || [],
        section: parseMainSection(page.path)
      },
      openGraph: {
        enabled: true,
        pageDescription: (article === null || article === void 0 ? void 0 : article.metadataDescription) || article.lead,
        pageLocale: 'pt_BR',
        pageTitle: (article === null || article === void 0 ? void 0 : article.metadataTitle) !== '' ? article === null || article === void 0 ? void 0 : article.metadataTitle : article === null || article === void 0 ? void 0 : article.name,
        pageType: 'article',
        pageUrl: "".concat(domain).concat(article.path),
        siteName: site === null || site === void 0 ? void 0 : site.name
      },
      openGraphImages: {
        enabled: true,
        pageImages: (images === null || images === void 0 ? void 0 : images.length) > 0 ? images : [{
          secureUrl: "".concat(domain).concat(thumbData === null || thumbData === void 0 ? void 0 : thumbData.url),
          url: "".concat(domain).concat(thumbData === null || thumbData === void 0 ? void 0 : thumbData.url),
          type: thumbData === null || thumbData === void 0 ? void 0 : thumbData.type,
          height: thumbData === null || thumbData === void 0 ? void 0 : thumbData.height,
          width: thumbData === null || thumbData === void 0 ? void 0 : thumbData.width
        }]
      },
      facebook: {
        enabled: true,
        appId: site === null || site === void 0 ? void 0 : (_site$pageSocialData = site.pageSocialData) === null || _site$pageSocialData === void 0 ? void 0 : _site$pageSocialData.facebookAppId,
        pageId: site === null || site === void 0 ? void 0 : (_site$pageSocialData2 = site.pageSocialData) === null || _site$pageSocialData2 === void 0 ? void 0 : _site$pageSocialData2.facebookPageId
      },
      twitter: {
        enabled: true,
        cardFormat: 'summary_large_image',
        creatorUsername: site === null || site === void 0 ? void 0 : (_site$pageSocialData3 = site.pageSocialData) === null || _site$pageSocialData3 === void 0 ? void 0 : _site$pageSocialData3.twitterContentCreator,
        description: (article === null || article === void 0 ? void 0 : article.metadataDescription) !== '' ? article === null || article === void 0 ? void 0 : article.metadataDescription : article !== null && article !== void 0 && article.lead ? article.lead : '',
        imageUrl: (images === null || images === void 0 ? void 0 : images.length) > 0 ? images[0].url : "".concat(domain).concat(thumbData === null || thumbData === void 0 ? void 0 : thumbData.url),
        siteUsername: site === null || site === void 0 ? void 0 : (_site$pageSocialData4 = site.pageSocialData) === null || _site$pageSocialData4 === void 0 ? void 0 : _site$pageSocialData4.twitterSiteCreator,
        title: (article === null || article === void 0 ? void 0 : article.metadataTitle) !== '' ? article === null || article === void 0 ? void 0 : article.metadataTitle : "".concat(article === null || article === void 0 ? void 0 : article.name, " | ").concat(site === null || site === void 0 ? void 0 : site.name),
        url: site === null || site === void 0 ? void 0 : site.siteDomain
      },
      gjcAnalytics: {
        enabled: true,
        responsavel: (article === null || article === void 0 ? void 0 : (_article$author = article.author) === null || _article$author === void 0 ? void 0 : _article$author.name) || '',
        authorOrigin: 'redacao',
        articleEditoria: page === null || page === void 0 ? void 0 : page.name,
        imageUrl: (images === null || images === void 0 ? void 0 : images.length) > 0 ? images[0].url : "".concat(domain).concat(thumbData === null || thumbData === void 0 ? void 0 : thumbData.url),
        sectionUrl: "".concat(site === null || site === void 0 ? void 0 : site.siteDomain).concat(page.path)
      },
      author: {
        enabled: true,
        author: (article === null || article === void 0 ? void 0 : (_article$author2 = article.author) === null || _article$author2 === void 0 ? void 0 : _article$author2.name) || ''
      },
      schemas: {
        enabled: true,
        article: {
          enabled: true,
          author: {
            '@type': 'Person',
            'name': (article === null || article === void 0 ? void 0 : (_article$author3 = article.author) === null || _article$author3 === void 0 ? void 0 : _article$author3.name) || ''
          },
          articleBody: article === null || article === void 0 ? void 0 : article.bodyParsed,
          dateModified: (0,parseTime/* formatTimeToISO */.N)(article === null || article === void 0 ? void 0 : article.modificationTime),
          datePublished: (0,parseTime/* formatTimeToISO */.N)(article === null || article === void 0 ? void 0 : article.publishingTime),
          description: article === null || article === void 0 ? void 0 : article.lead,
          headline: (article === null || article === void 0 ? void 0 : article.metadataTitle) !== '' ? article === null || article === void 0 ? void 0 : article.metadataTitle : article === null || article === void 0 ? void 0 : article.name,
          image: sImages,
          mainEntityOfPage: "".concat(site === null || site === void 0 ? void 0 : site.siteDomain).concat(article === null || article === void 0 ? void 0 : article.path),
          publisher: {
            '@type': 'Organization',
            'name': site === null || site === void 0 ? void 0 : site.pageTitle,
            logo: {
              '@type': 'ImageObject',
              'url': "".concat(site === null || site === void 0 ? void 0 : site.siteDomain, "/assets/opopular/favicons/96x96.png"),
              'height': '96',
              'width': '96'
            }
          },
          video: hasMediaVideoType !== null && hasMediaVideoType !== void 0 && hasMediaVideoType.enabled ? {
            '@type': 'VideoObject',
            'url': hasMediaVideoType.url,
            'name': hasMediaVideoType === null || hasMediaVideoType === void 0 ? void 0 : hasMediaVideoType.name,
            datePublished: hasMediaVideoType === null || hasMediaVideoType === void 0 ? void 0 : hasMediaVideoType.publishedDate
          } : undefined
        },
        organization: {
          enabled: true,
          name: site === null || site === void 0 ? void 0 : site.pageTitle,
          url: site === null || site === void 0 ? void 0 : site.siteDomain,
          logo: {
            '@type': 'ImageObject',
            'url': "".concat(site === null || site === void 0 ? void 0 : site.siteDomain, "/assets/opopular/favicons/96x96.png"),
            'height': '96',
            'width': '96'
          },
          parentOrganization: {
            '@type': 'Organization',
            '@id': 'https://www.gjccorp.com.br/',
            'name': 'Grupo Jaime Câmara'
          }
        },
        webpage: {
          enabled: false
        },
        website: {
          enabled: true,
          name: site === null || site === void 0 ? void 0 : site.pageTitle,
          description: site === null || site === void 0 ? void 0 : site.pageMetadata,
          url: site === null || site === void 0 ? void 0 : site.siteDomain
        }
      }
    };
  } else if (strategy_type === 'department') {
    return {
      viewport: {
        enabled: true,
        initialScale: '1',
        minimumScale: '1',
        shrinkToFit: true,
        viewportFit: 'cover',
        width: 'device-width'
      },
      title: {
        enabled: true,
        title: parseComposedTitle((page === null || page === void 0 ? void 0 : page.pageTitle) !== '' ? page.pageTitle : '', (page === null || page === void 0 ? void 0 : page.pageTitle) !== '' ? '' : page.path, site === null || site === void 0 ? void 0 : site.name)
      },
      description: {
        enabled: true,
        description: (page === null || page === void 0 ? void 0 : page.pageMetadata) !== '' ? page.pageMetadata : article === null || article === void 0 ? void 0 : article.lead
      },
      canonical: {
        enabled: true,
        url: "".concat(domain).concat(page === null || page === void 0 ? void 0 : page.path)
      },
      keywords: {
        enabled: true,
        keywords: page === null || page === void 0 ? void 0 : page.pageKeywords
      },
      openGraph: {
        enabled: true,
        pageDescription: page === null || page === void 0 ? void 0 : page.pageMetadata,
        pageLocale: 'pt_BR',
        pageTitle: parseComposedTitle((page === null || page === void 0 ? void 0 : page.pageTitle) !== '' ? page.pageTitle : '', (page === null || page === void 0 ? void 0 : page.pageTitle) !== '' ? '' : page.path, site.name),
        pageType: 'website',
        pageUrl: "".concat(domain).concat(serverSideContext.page.path),
        siteName: site.name
      },
      openGraphImages: {
        enabled: true,
        pageImages: [{
          secureUrl: "".concat(domain).concat(thumbData.url),
          url: "".concat(domain).concat(thumbData.url),
          type: thumbData.type,
          height: thumbData.height,
          width: thumbData.width
        }]
      },
      facebook: {
        enabled: true,
        appId: site.pageSocialData.facebookAppId,
        pageId: site.pageSocialData.facebookPageId
      },
      twitter: {
        enabled: true,
        cardFormat: 'summary_large_image',
        description: page.pageMetadata !== '' ? page.pageMetadata : article.lead,
        imageUrl: "".concat(domain).concat(thumbData.url),
        siteUsername: site.pageSocialData.twitterSiteCreator,
        title: parseComposedTitle(page.pageTitle !== '' ? page.pageTitle : '', page.pageTitle !== '' ? '' : page.path, site.name),
        url: site.siteDomain
      },
      schemas: {
        enabled: true,
        article: {
          enabled: false
        },
        organization: {
          enabled: true,
          name: site.pageTitle,
          url: site.siteDomain,
          logo: {
            '@type': 'ImageObject',
            'url': "".concat(site.siteDomain, "/assets/opopular/favicons/96x96.png"),
            'height': '96',
            'width': '96'
          },
          parentOrganization: {
            '@type': 'Organization',
            '@id': 'https://www.gjccorp.com.br/',
            'name': 'Grupo Jaime Câmara'
          }
        },
        webpage: {
          enabled: true,
          name: page.pageTitle !== '' ? page.pageTitle : page.name,
          description: page.pageMetadata,
          url: "".concat(site.siteDomain).concat(page.path),
          image: "".concat(site.siteDomain, "/assets/opopular/banners/BannerSocialShare.png")
        },
        website: {
          enabled: true,
          name: site.pageTitle,
          description: site.pageMetadata,
          url: site.siteDomain
        }
      }
    };
  } else if (strategy_type === 'home') {
    return {
      viewport: {
        enabled: true,
        initialScale: '1',
        minimumScale: '1',
        shrinkToFit: true,
        viewportFit: 'cover',
        width: 'device-width'
      },
      title: {
        enabled: true,
        title: (site === null || site === void 0 ? void 0 : site.pageTitle) !== '' ? site.pageTitle : site.name
      },
      description: {
        enabled: true,
        description: site.pageMetadata
      },
      canonical: {
        enabled: true,
        url: "".concat(domain).concat(site.path)
      },
      keywords: {
        enabled: true,
        keywords: site.pageKeywords
      },
      openGraph: {
        enabled: true,
        pageDescription: site.pageMetadata,
        pageLocale: 'pt_BR',
        pageTitle: (site === null || site === void 0 ? void 0 : site.pageTitle) !== '' ? site.pageTitle : site.name,
        pageType: 'website',
        pageUrl: "".concat(domain).concat(serverSideContext.site.path),
        siteName: site.name
      },
      openGraphImages: {
        enabled: true,
        pageImages: [{
          secureUrl: "".concat(domain).concat(thumbData.url),
          url: "".concat(domain).concat(thumbData.url),
          type: thumbData.type,
          height: thumbData.height,
          width: thumbData.width
        }]
      },
      facebook: {
        enabled: true,
        appId: site.pageSocialData.facebookAppId,
        pageId: site.pageSocialData.facebookPageId
      },
      twitter: {
        enabled: true,
        cardFormat: 'summary_large_image',
        description: site.pageMetadata,
        imageUrl: "".concat(domain).concat(thumbData.url),
        siteUsername: site.pageSocialData.twitterSiteCreator,
        title: (site === null || site === void 0 ? void 0 : site.pageTitle) !== '' ? site.pageTitle : site.name,
        url: site.siteDomain
      },
      schemas: {
        enabled: true,
        article: {
          enabled: false
        },
        organization: {
          enabled: true,
          name: site === null || site === void 0 ? void 0 : site.pageTitle,
          url: site.siteDomain,
          logo: {
            '@type': 'ImageObject',
            'url': "".concat(site.siteDomain, "/assets/opopular/favicons/96x96.png"),
            'height': '96',
            'width': '96'
          },
          parentOrganization: {
            '@type': 'Organization',
            '@id': 'https://www.gjccorp.com.br/',
            'name': 'Grupo Jaime Câmara'
          }
        },
        webpage: {
          enabled: true,
          name: site === null || site === void 0 ? void 0 : site.pageTitle,
          description: site.pageMetadata,
          url: site.siteDomain,
          image: "".concat(site.siteDomain, "/assets/opopular/banners/BannerSocialShare.png")
        },
        website: {
          enabled: true,
          name: site === null || site === void 0 ? void 0 : site.pageTitle,
          description: site.pageMetadata,
          url: site.siteDomain
        }
      }
    };
  }
};
;// CONCATENATED MODULE: ./providers/Seo/title/index.tsx


function useTitle(_ref) {
  var enabled = _ref.enabled,
      title = _ref.title;

  if (!enabled) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("title", {
      children: title
    })
  });
}
;// CONCATENATED MODULE: ./providers/Seo/twitter/index.tsx



function useTwitterSEO(_ref) {
  var enabled = _ref.enabled,
      cardFormat = _ref.cardFormat,
      creatorUsername = _ref.creatorUsername,
      description = _ref.description,
      imageUrl = _ref.imageUrl,
      siteUsername = _ref.siteUsername,
      title = _ref.title,
      url = _ref.url;

  if (!enabled) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
  }

  var twitterSite;

  if (url && url.includes('popular')) {
    twitterSite = '@jornal_opopular';
  } else if (url && url.includes('tocantins')) {
    twitterSite = '@jornaltocantins';
  } else if (url && url.includes('daqui')) {
    twitterSite = '@meudaqui';
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [cardFormat && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "twitter:card",
      content: cardFormat
    }, 'twitter_card'), creatorUsername && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "twitter:creator",
      content: creatorUsername
    }, 'twitter_creator'), description && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "twitter:description",
      content: description
    }, 'twitter_description'), siteUsername && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "twitter:site",
      content: siteUsername
    }, 'twitter_site'), title && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "twitter:title",
      content: title
    }, 'twitter_title'), imageUrl && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "twitter:image",
      content: imageUrl
    }, 'twitter_image'), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "twitter:site",
      content: twitterSite
    }, 'twitter:site')]
  });
}
;// CONCATENATED MODULE: ./providers/Seo/useAppleTouchIconMetatags/index.tsx


function useAppleTouchIconMetatags(_ref) {
  var enabled = _ref.enabled,
      favicons = _ref.favicons,
      site = _ref.site;

  if (!enabled) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
  }

  var elements = favicons.map(function (i) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "apple-touch-icon",
      href: "/assets/".concat(site.slug, "/favicons/").concat(i.fullName),
      sizes: i.name,
      type: "image/png"
    }, "appltouchicon-".concat(i.name));
  });
  return elements;
}
;// CONCATENATED MODULE: ./providers/Seo/useGoogleFonts/index.tsx



function useGoogleFonts(_ref) {
  var enabled = _ref.enabled,
      slug = _ref.slug;

  if (!enabled) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
  }

  var themeFamilies = [{
    id: 'cbn',
    families: [0, 2]
  }, {
    id: 'cbngo',
    families: [0, 2]
  }, {
    id: 'cbnto',
    families: [0, 2]
  }, {
    id: 'daqui',
    families: [0, 3]
  }, {
    id: 'opopular',
    families: [0]
  }, {
    id: 'tocantins',
    families: [0, 1]
  }];
  var avbFamilies = [{
    id: 'Fira Sans Condensed',
    weights: [300, 400, 500, 600, 700],
    param: 'family=Fira+Sans+Condensed:wght@'
  }, {
    id: 'IBM Plex Sans Condensed',
    weights: [300, 400, 500, 600, 700],
    param: 'family=IBM+Plex+Sans+Condensed:wght@'
  }, {
    id: 'Roboto Slab',
    weights: [300, 400, 500, 600, 700],
    param: 'family=Roboto+Slab:wght@'
  }, {
    id: 'Roboto Condensed',
    weights: [300, 400, 700],
    param: 'family=Roboto+Condensed:wght@'
  }];
  var selectedFromThemeFamilies = themeFamilies.find(function (i) {
    return i.id === slug;
  });
  var selectedFromAvbFamilies = [];
  (selectedFromThemeFamilies === null || selectedFromThemeFamilies === void 0 ? void 0 : selectedFromThemeFamilies.families) && (selectedFromThemeFamilies === null || selectedFromThemeFamilies === void 0 ? void 0 : selectedFromThemeFamilies.families.map(function (i) {
    return avbFamilies[i] && selectedFromAvbFamilies.push(avbFamilies[i]);
  }));
  var finalStringParam = [];
  selectedFromAvbFamilies.map(function (i) {
    return finalStringParam.push("".concat(i.param).concat(i.weights.join(';')));
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "preconnect",
      href: "https://fonts.googleapis.com"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "preconnect",
      href: "https://fonts.gstatic.com",
      crossOrigin: "true"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      href: "https://fonts.googleapis.com/css2?".concat(finalStringParam.join('&'), "&display=swap"),
      rel: "stylesheet"
    })]
  });
}
;// CONCATENATED MODULE: ./providers/Seo/useIconMetatags/index.tsx


function useIconMetatags(_ref) {
  var enabled = _ref.enabled,
      favicons = _ref.favicons,
      site = _ref.site;

  if (!enabled) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
  }

  var elements = favicons.map(function (i) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "icon",
      href: "/assets/".concat(site.slug, "/favicons/").concat(i.fullName),
      sizes: i.name,
      type: "image/png"
    }, "icon-".concat(i.name));
  });
  return elements;
}
;// CONCATENATED MODULE: ./providers/Seo/useManifest/index.tsx


function useManifest(_ref) {
  var enabled = _ref.enabled,
      site = _ref.site;

  if (!enabled) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
    rel: "manifest",
    href: "/manifest/".concat(site, ".json")
  });
}
;// CONCATENATED MODULE: ./providers/Seo/useMobileConfig/index.tsx



function useMobileConfig(_ref) {
  var enabled = _ref.enabled;

  if (!enabled) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "apple-mobile-web-app-capable",
      content: "yes"
    }, 'apple-mobile-web-app-capable'), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "apple-mobile-web-app-status-bar-style",
      content: "default"
    }, 'apple-mobile-web-app-status-bar-style'), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "mobile-web-app-capable",
      content: "yes"
    }, 'mobile-web-app-capable')]
  });
}
;// CONCATENATED MODULE: ./providers/Seo/useSplashScreen/index.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



function useSplashScreen(_ref) {
  var enabled = _ref.enabled,
      site = _ref.site,
      splashScreens = _ref.splashScreens;

  if (!enabled) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
  }

  var splashScreensRegister = [{
    "name": "iphone5.png",
    "media": "(device-width: 320px) and (device-height: 568px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)",
    "rel": "apple-touch-startup-image"
  }, {
    "name": "iphone6.png",
    "media": "(device-width: 375px) and (device-height: 667px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)",
    "rel": "apple-touch-startup-image"
  }, {
    "name": "iphoneplus.png",
    "media": "(device-width: 621px) and (device-height: 1104px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)",
    "rel": "apple-touch-startup-image"
  }, {
    "name": "iphonex.png",
    "media": "(device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)",
    "rel": "apple-touch-startup-image"
  }, {
    "name": "iphonexr.png",
    "media": "(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)",
    "rel": "apple-touch-startup-image"
  }, {
    "name": "iphonexsmax.png",
    "media": "(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)",
    "rel": "apple-touch-startup-image"
  }, {
    "name": "ipad.png",
    "media": "(device-width: 768px) and (device-height: 1024px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)",
    "rel": "apple-touch-startup-image"
  }, {
    "name": "ipadpro1.png",
    "media": "(device-width: 834px) and (device-height: 1112px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)",
    "rel": "apple-touch-startup-image"
  }, {
    "name": "ipadpro3.png",
    "media": "(device-width: 834px) and (device-height: 1194px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)",
    "rel": "apple-touch-startup-image"
  }, {
    "name": "ipadpro2.png",
    "media": "(device-width: 1024px) and (device-height: 1366px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)",
    "rel": "apple-touch-startup-image"
  }];
  var registeredScreens = splashScreens.map(function (i) {
    var selected = splashScreensRegister.find(function (s) {
      return s.name === i.fullName;
    });

    if (selected && selected.name) {
      return _objectSpread(_objectSpread({}, i), selected);
    } else {
      return _objectSpread({}, i);
    }
  });
  var elements = registeredScreens.map(function (i) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      href: i.url,
      media: i.media,
      rel: i.rel
    }, "splashScreen-".concat(i.name));
  });
  return elements;
}
;// CONCATENATED MODULE: ./providers/Seo/viewport/index.tsx


function useViewport(_ref) {
  var enabled = _ref.enabled,
      width = _ref.width,
      height = _ref.height,
      initialScale = _ref.initialScale,
      minimumScale = _ref.minimumScale,
      maximumScale = _ref.maximumScale,
      userScalable = _ref.userScalable,
      shrinkToFit = _ref.shrinkToFit,
      viewportFit = _ref.viewportFit;

  if (!enabled) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
  }

  var viewportContent = [];

  if (width) {
    viewportContent.push("width=".concat(width));
  }

  if (height) {
    viewportContent.push("height=".concat(height));
  }

  if (initialScale) {
    viewportContent.push("initial-scale=".concat(initialScale));
  }

  if (minimumScale) {
    viewportContent.push("minimum-scale=".concat(minimumScale));
  }

  if (maximumScale) {
    viewportContent.push("maximum-scale=".concat(maximumScale));
  }

  if (userScalable) {
    viewportContent.push("user-scalable=".concat(userScalable));
  }

  if (shrinkToFit) {
    viewportContent.push("shrink-to-fit=no");
  }

  if (viewportFit) {
    viewportContent.push("viewport-fit=".concat(viewportFit));
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "viewport",
      content: viewportContent.join(', ')
    }, 'viewport')
  });
}
;// CONCATENATED MODULE: ./providers/Scripts/useHotjar/index.tsx


var versions = {
  opopular: '1.0'
};
function useHotjar(_ref) {
  var enabled = _ref.enabled,
      slug = _ref.slug;
  var slugVersion = versions[slug];

  if (!enabled || !slugVersion) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
      async: true,
      type: "text/javascript",
      src: "/scripts/hotjar-".concat(slug, ".js?v=").concat(versions[slug])
    }, 'hotjar-settings')
  });
}
;// CONCATENATED MODULE: ./providers/Seo/index.tsx


function Seo_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Seo_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Seo_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Seo_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }












 // import { useArticleSchema } from './schemas/article'
// import { useOrganizationSchema } from './schemas/organization'
// import { useWebPage } from './schemas/webpage'
// import { useWebSite } from './schemas/website'











// import { useGjcAnalyticsTags } from './gjcAnalytics'



var SeoProvider = function SeoProvider(_ref) {
  var children = _ref.children;
  var data = useSeoStrategy();
  var serverSideContext = (0,react.useContext)(ServerSideProps.ServerSidePropsContext);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [useAppleTouchIconMetatags({
        enabled: true,
        favicons: serverSideContext.siteConfig.assets.favicons,
        site: serverSideContext.siteConfig
      }), useAuthor(Seo_objectSpread({
        enabled: true
      }, data === null || data === void 0 ? void 0 : data.author)), useCanonical(Seo_objectSpread({
        enabled: true
      }, data === null || data === void 0 ? void 0 : data.canonical)), useDescription(Seo_objectSpread({
        enabled: true
      }, data === null || data === void 0 ? void 0 : data.description)), useFacebookSEO(Seo_objectSpread({
        enabled: true
      }, data === null || data === void 0 ? void 0 : data.facebook)), useIconMetatags({
        enabled: true,
        favicons: serverSideContext.siteConfig.assets.favicons,
        site: serverSideContext.siteConfig
      }), useKeywords(Seo_objectSpread({
        enabled: true
      }, data === null || data === void 0 ? void 0 : data.keywords)), useManifest({
        enabled: true,
        site: serverSideContext.siteConfig.slug
      }), useMobileConfig({
        enabled: true
      }), useOpenGraphArticle(Seo_objectSpread({
        enabled: true
      }, data === null || data === void 0 ? void 0 : data.openGraphArticle)), useOpenGraphImages(Seo_objectSpread({
        enabled: true
      }, data === null || data === void 0 ? void 0 : data.openGraphImages)), useOpenGraphProtocol(Seo_objectSpread({
        enabled: true
      }, data === null || data === void 0 ? void 0 : data.openGraph)), useRobots(Seo_objectSpread({
        enabled: true
      }, data === null || data === void 0 ? void 0 : data.robots)), useSplashScreen({
        enabled: true,
        site: serverSideContext.siteConfig.slug,
        splashScreens: serverSideContext.siteConfig.assets.splashScreens
      }), useTitle(Seo_objectSpread({
        enabled: true
      }, data === null || data === void 0 ? void 0 : data.title)), useTwitterSEO(Seo_objectSpread({
        enabled: true
      }, data === null || data === void 0 ? void 0 : data.twitter)), useViewport(Seo_objectSpread({
        enabled: true
      }, data === null || data === void 0 ? void 0 : data.viewport)), useGoogleFonts({
        enabled: true,
        slug: serverSideContext.siteConfig.slug
      }), useHotjar({
        enabled: true,
        slug: serverSideContext.siteConfig.slug
      })]
    }), children]
  });
};

/* harmony default export */ var Seo = (SeoProvider);

/***/ }),

/***/ 586:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ getPageTitleFromPath; }
/* harmony export */ });
/* unused harmony export getDepFromNav */
/* harmony import */ var lodash_find__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3311);
/* harmony import */ var lodash_find__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_find__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_1__);


var getDepFromNav = function getDepFromNav(navigation, pathName) {
  var pathParsed = pathName;
  var items = [];
  var itemSelected = {};

  if (!!pathParsed) {
    navigation === null || navigation === void 0 ? void 0 : navigation.map(function (pqueue) {
      pqueue === null || pqueue === void 0 ? void 0 : pqueue.map(function (queue) {
        var _queue$contentData;

        queue === null || queue === void 0 ? void 0 : (_queue$contentData = queue.contentData) === null || _queue$contentData === void 0 ? void 0 : _queue$contentData.map(function (entry) {
          items.push(entry);
        });
      });
    });
    items === null || items === void 0 ? void 0 : items.map(function (item) {
      var _item$path;

      if (item !== null && item !== void 0 && (_item$path = item.path) !== null && _item$path !== void 0 && _item$path.endsWith(pathParsed)) {
        itemSelected = item;
      }
    });
  }

  return itemSelected;
};
var getPageTitleFromPath = function getPageTitleFromPath(nav, d) {
  var getFromList = function getFromList(p) {
    return lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(lodash_find__WEBPACK_IMPORTED_MODULE_0___default()(nav, {
      path: p
    }), 'name');
  };

  var slugs = [];
  var s = d.split('/');

  if (s.length > 3) {
    slugs.push("/".concat(s[1], "/").concat(s[2], "/").concat(s[3]));
  } else if (s.length > 2) {
    slugs.push("/".concat(s[1], "/").concat(s[2]));
  } else if (s.length > 1) {
    slugs.push("/".concat(s[1]));
  }

  var titles = [];

  for (var i = 0; i < slugs.length; i++) {
    titles.push(getFromList(slugs[i]));
  }

  return titles;
};

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(2717)


/***/ })

}]);